export default "/fonts/Urbanist-Light.ttf?f9f2ec15b04dd4b51a4ced81c0a90896";